// extracted by mini-css-extract-plugin
module.exports = {"topContainer":"WeOfferSectionCHM_topContainer__xPZMH WeOfferSection_topContainer__WhkA9"};